<template>
    <div class="orders-table" v-if="orders && orders.length">

        <table>
            <thead>
                <th>Діагноз</th>
                <th>Вік</th>
                <th>Потреба на рік</th>
                <th>Залишки станом початок року</th>
                <th>Очікується поставка за попередній рік</th>
                <th>Очікується поставка в цьому році</th>
            </thead>

            <tbody>
                <tr v-for="(o, index) in orders" :key="index">
                    <td>{{ o.desease }}</td>
                    <td>{{ o.age }}</td>
                    <td>{{ o.year_needs }}</td>
                    <td>{{ o.year_balance }}</td>
                    <td>{{ o.last_year_supply }}</td>
                    <td>{{ o.next_year_supply }}</td>
                </tr>
            </tbody>

        </table>
    </div>
</template>

<script>
import * as d3_array from 'd3-array'

export default {
    props: ['orders'],
}
</script>

<style lang="scss" scoped>
table {
    border-collapse: collapse;
    
    tr { 
        
    }

    td, th{
        font-size: 0.8rem;
        border: 1px solid black;
        color: var(--col-mainblue);
        padding: 0.5rem;
    }

    th {
        font-size: 0.8rem;
        font-weight: 600;
    }

    .count {text-align: right;}

    thead th {
        border-top: 0;
    }

    tr td:first-child,
    thead th:first-child {
        border-left: 0;
    }
    tr:last-child td {
        border-bottom: 0;
    }
    tr td:last-child,
    thead, th:last-child {
        border-right: 0;
    }
}




</style>